import React from 'react';
import { Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
export function FloatingCTA() {
  const {
    t
  } = useLanguage();
  return <motion.div initial={{
    y: 100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    delay: 2,
    duration: 0.5,
    ease: 'easeOut'
  }} className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-brand-red shadow-2xl shadow-brand-red/30 safe-area-bottom" data-id="element-33">
      <a href="tel:8324397965" className="flex items-center justify-center gap-3 w-full py-4 px-6 text-white font-bold text-lg" data-id="element-34">
        <Phone className="w-6 h-6 animate-pulse" data-id="element-35" />
        {t.floatingCta}
      </a>
    </motion.div>;
}